//import ThemeButton from "components/Buttons/ThemeButton";
import ThemeButton from "components/Buttons/ThemeButton";
import styled from "styled-components";

export const Container = styled.div<{ scale: number; backgroundImage: string }>`
	width: 400px;
	height: 714px;
	background-color: #fff;
	border-radius: 16px;
	position: relative;
	overflow: hidden;
	transform: scale(${(props) => props.scale});
	background-repeat: no-repeat;
	background-position: cover;
	background-size: cover;
	background-image: url(${(props) => props.backgroundImage});
	font-size: 30px;

	@media (orientation: landscape) {
		font-size: 29.5px;
		width: 1002px;
		height: 430px;
	}
`;

export const Body = styled.div`
	position: absolute;
	display: flex;
	flex-direction: column;
	width: 90%;
	height: 100%;
	top: 8%;
	left: 50%;
	transform: translateX(-50%);
	gap: 0.5em;

	&.claimed {
		top: 6%;
		gap: 0.3em;
	}

	@media (orientation: landscape) {
		width: 50%;
		height: 100%;
		top: 1.4em;
		right: 1.6em;
		left: unset;
		transform: unset;
		gap: 0.4em;

		&.claimed {
			top: 10%;
			gap: 0.5em;
		}
	}
`;

export const Items = styled.div`
	display: flex;
	justify-content: center;
	align-items: center;
	gap: 1rem;
`;

export const Title = styled.div`
	color: #113b62;
	text-align: center;
	font-family: Baloo;
	font-size: 1.86em;
	font-style: normal;
	font-weight: 400;
	line-height: 0.85em;

	&.claimed {
		font-size: 1.6em;
	}

	@media (orientation: landscape) {
		&.claimed {
			font-size: 1.7em;
		}
	}
`;

export const SubTitle = styled.div`
	color: #000;
	text-align: center;
	font-family: Inter;
	font-size: 0.62em;
	font-style: normal;
	font-weight: 700;
	line-height: 1.3em;

	@media (orientation: landscape) {
		font-size: 0.57em;
	}
`;

export const Footer = styled.div`
	color: #000;
	text-align: center;
	font-family: Inter;
	font-style: italic;

	font-size: 0.46em;
	font-weight: 700;

	@media (orientation: landscape) {
		font-size: 0.57em;
		font-weight: 500;
	}
`;

export const ButtonContainer = styled.div`
	display: flex;
	justify-content: center;
	align-items: center;
	margin-top: 6.7em;

	&.claimed {
		margin-top: 7.6em;
	}

	@media (orientation: landscape) {
		margin-top: unset;

		&.claimed {
			margin-top: unset;
		}
	}
`;

export const Button = styled(ThemeButton)`
	padding: 0.2rem;
	width: 90%;
	font-size: 0.53em;
`;

export const Box = styled.div`
	background-color: rgba(0, 0, 0, 0.25);
	border-radius: 15px;
	width: 4.3em;
	height: 3.8em;
	display: flex;
	justify-content: center;
	align-items: center;

	@media (orientation: landscape) {
		width: 3.9em;
		height: 3.7em;
	}
`;

export const RewardItem = styled.div`
	display: flex;
	flex-direction: column;
	justify-content: center;
	align-items: center;
	box-sizing: border-box;
	position: relative;
	//padding: 0.21em;
`;

export const RewardAmountContainer = styled.div`
	position: absolute;
	min-width: 100%;
	display: flex;
	align-items: center;
	justify-content: center;
	bottom: -0.76em;
`;

export const RewardAmount = styled.div`
	color: #fff;
	font-weight: 700;
	font-size: 1.16em;
	width: 100%;
	display: flex;
	align-items: center;
	justify-content: right;
	font-family: "Baloo";
	font-weight: 300;
	text-shadow: 0.071em 0.071em 0em #000;
	-webkit-text-stroke-width: 0.12em;
	-webkit-text-stroke-color: #000;
	paint-order: stroke fill;
`;

export const ItemImage = styled.img`
	min-width: 2.5em;
	height: 2.5em;
	object-fit: contain;
	justify-self: center;
	align-self: center;
`;
